export enum Routes {
  AuthenticationMethodSelection = '/authentication-method-selection',
  Deed = '/deed/:deedId',
  DeedPreview = '/deed/preview/:deedId/:documentIdentifier',
  Register = '/register/:registrationId/:actId',
  Login = '/',
  LogoutSuccess = '/logout-success',
  Overview = '/overview',
}
